export const aliasesList = [
  '--Analogue-list-borderRadius',
  '--Analogue-list-colorBorderActive',
  '--Brand-Primary-colorPrimary',
  '--Brand-Primary-colorPrimaryHover',
  '--Brand-Primary-colorPrimaryActive',
  '--Brand-Primary-colorPrimaryTextActive',
  '--Brand-Primary-colorPrimaryBorderHover',
  '--Brand-Link-colorLink',
  '--Brand-Link-colorLinkActive',
  '--Components-Checkbox-Global-colorPrimary',
  '--Components-Input-Component-hoverBorderColor',
  '--Components-Input-Component-activeBorderColor',
  '--Components-Typography-Global-colorText',
  '--Components-Typography-Global-colorLink',
  '--Product-card-colorBorder',
  '--Product-card-colorBorderHover',
  '--Header-colorBGProductCategoriesButton',
  '--Header-colorBGProductCategoriesButtonHover',
  '--Category-Card-colorBgContainerFilled',
  '--Category-Card-colorBgContainer',
  '--Category-Card-colorHoverBorder',
  '--Category-Card-colorActiveBorder',
  '--Car-Brands-colorBorder',
  '--Car-Brands-colorBorderHover',
  '--Car-Brands-colorBorderActive',
  '--Neutral-Border-colorBorder',
  '--Cart-in-header-colorQuantityDefault',
  '--Neutral-Text-colorText',
  '--Components-Button-Global-colorPrimary',
  '--Components-Button-Global-colorPrimaryHover',
  '--Components-Button-Global-colorPrimaryActive',
  '--Components-Button-Global-borderRadius',
  '--Components-Button-Global-controlOutlineWidth',
  '--Components-Button-Global-controlOutline',
  '--Components-Button-Component-defaultBg',
  '--Components-Button-Component-defaultColor',
  '--Components-Button-Component-defaultHoverBg',
  '--Components-Button-Component-defaultHoverColor',
  '--Components-Button-Component-defaultHoverBorderColor',
  '--Components-Button-Component-defaultActiveBg',
  '--Components-Button-Component-defaultActiveColor',
  '--Components-Button-Component-defaultActiveBorderColor',
  '--Header-colorBorderSearchInput',
  '--Components-Input-Global-colorIcon',
];